import React from 'react'
import {Button} from 'react-bootstrap'

import {VisibilityContext} from 'react-horizontal-scrolling-menu'

function Arrow({
  children,
  disabled,
  onClick,
}: {
  children: React.ReactNode
  disabled: boolean
  onClick: VoidFunction
}) {
  return (
    <Button
      variant='link'
      disabled={disabled}
      onClick={onClick}
      className='p-0'
      style={{
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        opacity: disabled ? '0' : '1',
        userSelect: 'none',
      }}
    >
      {children}
    </Button>
  )
}

export function LeftArrow() {
  const {isFirstItemVisible, scrollPrev, visibleElements, initComplete} =
    React.useContext(VisibilityContext)

  const [disabled, setDisabled] = React.useState(
    !initComplete || (initComplete && isFirstItemVisible)
  )
  React.useEffect(() => {
    // NOTE: detect if whole component visible
    if (visibleElements.length) {
      setDisabled(isFirstItemVisible)
    }
  }, [isFirstItemVisible, visibleElements])

  return (
    <Arrow disabled={disabled} onClick={() => scrollPrev()}>
      <i className='fa-solid fa-chevron-left'></i>
    </Arrow>
  )
}

export function RightArrow() {
  const {isLastItemVisible, scrollNext, visibleElements} = React.useContext(VisibilityContext)

 
  const [disabled, setDisabled] = React.useState(!visibleElements.length && isLastItemVisible)
  React.useEffect(() => {
    if (visibleElements.length) {
      setDisabled(isLastItemVisible)
    }
  }, [isLastItemVisible, visibleElements])

  return (
    <Arrow disabled={disabled} onClick={() => scrollNext()}>
      <i className='fa-solid fa-chevron-right'></i>
    </Arrow>
  )
}
